module.exports = __webpack_public_path__ + "img/P8.6964ba5d.png";